import { render } from "./add_delivery_component.vue?vue&type=template&id=8c347bb8&scoped=true"
import script from "./add_delivery_component.vue?vue&type=script&lang=js"
export * from "./add_delivery_component.vue?vue&type=script&lang=js"

import "./add_delivery_component.vue?vue&type=style&index=0&id=8c347bb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c347bb8"]])

export default __exports__